"use client";
import React from "react";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0B0B0B] via-[#101100] to-[#111] text-white">
      {/* Top bar */}
      <div className="w-full h-1 bg-[#C6FF00]" />

      {/* Header */}
      <header className="sticky top-0 z-40 backdrop-blur bg-black/60 border-b border-white/10 mb-10">
        <div className="max-w-6xl mx-auto px-4 py-5 flex items-center justify-between">
          <a
            href="/"
            className="flex items-center gap-3 text-[#C6FF00] hover:opacity-80 transition"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="font-semibold">Zpět na hlavní stránku</span>
          </a>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-xl bg-[#C6FF00] grid place-items-center ring-1 ring-black/10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="black"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 9.75L12 4.5l9 5.25M4.5 10.5v9.75h15V10.5M9 21V12h6v9"
                />
              </svg>
            </div>
            <div>
              <div className="text-lg font-bold">VisionHome</div>
              <div className="text-xs text-white/60 -mt-0.5">
                Materiály • Poradenství • Finance • Reality
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 pb-20">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-center text-[#C6FF00]">
          Ochrana osobních údajů
        </h1>

        <section className="space-y-6 text-white/80 leading-relaxed">
          <p>
            Vážení návštěvníci, ochrana vašich osobních údajů je pro společnost{" "}
            <span className="text-[#C6FF00] font-semibold">VisionHome</span>{" "}
            velmi důležitá. Tento dokument vysvětluje, jakým způsobem
            zpracováváme vaše osobní údaje v souladu s nařízením Evropského
            parlamentu a Rady (EU) 2016/679 (GDPR).
          </p>

          <h2 className="text-2xl font-semibold text-[#C6FF00] mt-10">
            1️⃣ Správce osobních údajů
          </h2>
          <p>
            Správcem osobních údajů je společnost{" "}
            <span className="text-[#C6FF00] font-semibold">VisionHome</span>,
            se sídlem Jiráskova 802, Benešov 256 01,  
            IČO: 016 39 889.  
            <br />
            E-mail:{" "}
            <a
              href="mailto:info@visionhome.cz"
              className="text-[#C6FF00] hover:underline"
            >
              info@visionhome.cz
            </a>
          </p>

          <h2 className="text-2xl font-semibold text-[#C6FF00] mt-10">
            2️⃣ Jaké údaje zpracováváme
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Jméno a příjmení</li>
            <li>E-mailová adresa a telefonní číslo</li>
            <li>Adresa nebo místo projektu (pokud je uvedeno)</li>
            <li>Obsah zpráv, poptávek a příloh zaslaných prostřednictvím formulářů</li>
          </ul>

          <h2 className="text-2xl font-semibold text-[#C6FF00] mt-10">
            3️⃣ Účel zpracování
          </h2>
          <p>Osobní údaje zpracováváme výhradně za účelem:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>vyřízení vaší poptávky nebo žádosti,</li>
            <li>přípravy individuální cenové nabídky,</li>
            <li>komunikace ohledně projektů, realizací nebo financování,</li>
            <li>zasílání odpovědí na dotazy či odborných doporučení.</li>
          </ul>

          <h2 className="text-2xl font-semibold text-[#C6FF00] mt-10">
            4️⃣ Doba uchování údajů
          </h2>
          <p>
            Údaje uchováváme po dobu nezbytně nutnou pro vyřízení vaší žádosti
            a následnou komunikaci, nejdéle však po dobu 3 let, pokud právní
            předpisy nevyžadují delší uchování.
          </p>

          <h2 className="text-2xl font-semibold text-[#C6FF00] mt-10">
            5️⃣ Vaše práva
          </h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Právo na přístup k osobním údajům</li>
            <li>Právo na opravu nebo výmaz údajů</li>
            <li>Právo na omezení zpracování</li>
            <li>Právo vznést námitku proti zpracování</li>
            <li>Právo podat stížnost u Úřadu pro ochranu osobních údajů (www.uoou.cz)</li>
          </ul>

          <h2 className="text-2xl font-semibold text-[#C6FF00] mt-10">
            6️⃣ Zabezpečení údajů
          </h2>
          <p>
            Vaše osobní údaje chráníme pomocí moderních technických a
            organizačních opatření, která zamezují neoprávněnému přístupu,
            ztrátě nebo zneužití údajů. Přístup k údajům mají pouze pověřené
            osoby.
          </p>

          <h2 className="text-2xl font-semibold text-[#C6FF00] mt-10">
            7️⃣ Závěrečná ustanovení
          </h2>
          <p>
            Tento dokument může být aktualizován v souladu s platnou legislativou.
            Aktuální verze je vždy dostupná na adrese{" "}
            <span className="text-[#C6FF00]">www.visionhome.cz/ochrana-osobnich-udaju</span>.
          </p>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/10 py-10 text-center text-white/70 text-sm bg-black/70">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-3">
          <div>
            © {new Date().getFullYear()} VisionHome, Jiráskova 802, Benešov 256 01 · IČO 016 39 889
          </div>
          <div className="flex items-center gap-6">
            <a href="mailto:info@visionhome.cz" className="hover:text-[#C6FF00]">
              info@visionhome.cz
            </a>
            <span className="text-white/40">•</span>
            <a href="tel:+420720599022" className="hover:text-[#C6FF00]">
              +420 720 599 022
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
